import { render, staticRenderFns } from "./OpLabelField.vue?vue&type=template&id=f7869632&"
import script from "./OpLabelField.vue?vue&type=script&lang=js&"
export * from "./OpLabelField.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports